import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';


import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { INTERNODO_ENDPOINT, INTERNODO_QUERY_SERVICE_INSTANCE } from '../filiere.config';
import { InterNodo } from '../internodo.model';

@Injectable({
  providedIn: 'root'
})
export class InterNodeService extends CrudService<InterNodo> {

  constructor(
    @Inject(INTERNODO_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<InterNodo>,
    public readonly apiService:ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    super(INTERNODO_ENDPOINT, apiService, snackbar);
  }
  getAll<InterNodo>(parameter : IPageEvent,filter:string, idNodes:any, searchData?:any){
    const filtro = filter.length>0 ? `&filter=${encodeURIComponent(filter)}` : ``
    const stringSearch = searchData ? `&search=${searchData}` : ``
    const sort = `&sortBy=${encodeURIComponent('createdAt:DESC')}`
    const idNodesQuery = idNodes.join('|')
    return this.apiService.get(INTERNODO_ENDPOINT+"?filter="+encodeURIComponent("startNodeId.id||in||"+idNodesQuery)+"&filter="+encodeURIComponent("endNodeId.id||in||"+idNodesQuery)+"&page="+parameter.pageIndex+"&limit="+parameter.pageSize)
  }


  massiveDelete(ids: number[]) : any{ 
    return this.apiService.delete(INTERNODO_ENDPOINT, 0, false, {ids: ids} );
  }


}
